/* eslint-disable camelcase */
import axios from 'axios';

const BillcomSettlementParentService = {
  async getBillComSettlementsParents({ page, limit }) {
    const response = await axios.get('/billcom_settlement_parent', {
      params: {
        page,
        per_page: limit,
        offset: 0,
      },
    });

    return response.data;
  },

  async getBillComSettlementParent(id) {
    const response = await axios.get(`/billcom_settlement_parent/${id}`);

    return response.data;
  },
};

export default BillcomSettlementParentService;
